import { APP_KEY, NEXT } from "@constants/auth.constant";
import { LOGIN } from "@constants/internal-route.constant";
import { useAuth } from "@context/Auth";

import { appLoginHelper } from "@services/helper/app.helper";
import { SessionStorageService } from "@services/utils/sessionStorage.service";
import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

const AppLogin = () => {
	const { isAuthenticated } = useAuth();
	const [searchParams] = useSearchParams();

	// Prefer the fresh query params, but fall back to the values stashed before the
	// login redirect — after signing in we return here without a query string, and the
	// hand-off still needs the target app + return URL to resume.
	const appKey = searchParams.get(APP_KEY) || SessionStorageService.get(APP_KEY);
	const next = searchParams.get(NEXT) || SessionStorageService.get(NEXT);

	useEffect(() => {
		if (appKey) SessionStorageService.set(APP_KEY, appKey);
		if (next) SessionStorageService.set(NEXT, next);
		if (isAuthenticated && next && appKey) {
			appLoginHelper();
		}
	}, [isAuthenticated, next, appKey]);

	if (!isAuthenticated) return <Navigate to={LOGIN} state={{ isAppLogin: true }} />;

	if (!next || !appKey) return <Navigate to={"/"} />;

	return (
		<div className="text-center py-4">
			<div className="spinner-border text-primary mb-3" role="status" aria-hidden="true" />
			<h1 className="h5 mb-1">Redirecting to the app…</h1>
			<p className="text-body-secondary mb-0">Please wait while we open your workspace.</p>
		</div>
	);
};

export default AppLogin;
